import img1 from "../assets/image1.jpg";
import img2 from "../assets/image2.jpg";
import img3 from "../assets/image3.jpg";
import img4 from "../assets/image4.jpg";
import img5 from "../assets/image5.jpg";
import img6 from "../assets/image6.jpg";
import img7 from "../assets/image7.jpg";
import img15 from "../assets/image15.jpg";
import img16 from "../assets/image16.jpg";
import DMAclub from "../assets/DMAclub.png";

export const clubData = [
  {
    id: img7,
    club: "SSA",
  },
  {
    id: img2,
    club: "HUMSS",
  },
  {
    id: img3,
    club: "STEM",
  },
  {
    id: img4,
    club: "YRC",
  },
  {
    id: img5,
    club: "ARTES",
  },
  {
    id: img6,
    club: "ABM",
  },
  {
    id: img1,
    club: "ITMAWE",
  },
  {
    id: img15,
    club: "COOKS",
  },
  {
    id: img16,
    club: "SESLE",
  },
  {
    id: DMAclub,
    club: "DMA",
  },
];
